import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { listPlatformConnections, SchemaQueryKeys, type PlatformConnectionResponse } from '../api';

/**
 * Lists platform-managed AI providers eligible for the tenant based on their license plan.
 * Returns an empty array when the plan has no platform providers configured.
 */
export function usePlatformConnections(): UseQueryResult<PlatformConnectionResponse[]> {
  return useQuery({
    queryKey: SchemaQueryKeys.platformConnections,
    queryFn: ({ signal }) => listPlatformConnections(signal),
  });
}
